<template>
    <div class="news-wrap">
        <div class="header-wrp">
            <Header></Header>
        </div>
        <div class="news-content-con">
            <div
                class="news-content"
                v-loading="loading"
                v-infinite-scroll="loadMore"
            >
                <div class="first-level-title">
                    <div class="first-level-title-inner">招标信息</div>
                </div>
                <ul class="ul-report">
                    <li v-for="(item,index) in lists" :key="index" class="li-flex">
                        <div class="li-item">
                            <div class="li-item-text">
                                <div class="text text-overflow">
                                    <a @click="goDetail(item.cntId)">{{item.title}}</a>
                                </div>
                                <div class="new" v-if="isNew(item.publishDate)"></div>
                            </div>
                            <div class="time">
                                {{item.publishDate.slice(0,10)}}
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import { sdmNews } from '@service'

export default {
    name: 'newsList',
    data() {
        return {
            loading: false,
            lists: [],
            noMore: false,
            currentPage: 1,
        }
    },
    mounted() {
        this.getList()
    },
    methods: {
        async getList() {
            this.loading = true
            let res = await sdmNews.getSdmNewsList({
                pageSize: 10,
                pageNum: this.currentPage,
            }).catch(() => {})
            this.loading = false
            if (!res) return
            let data = res.data.data.list || []
            if (data.length > 0) {
                this.lists = this.lists.concat(data)
            } else {
                this.noMore = true
            }
        },
        goDetail(id) {
            this.$router.push(`/news/${id}`)
        },
        loadMore() {
            if (!this.noMore && !this.loading) {
                this.currentPage++
                this.getList()
            }
        },
        isNew(time) {
            let current = Date.now()
            time = new Date(time).getTime()
            return current - time < 86400000
        },
    },
}
</script>

<style lang="scss" scope>
.news-content-con{
    padding: 208px 10px 10px;
    flex: 1;
    display: flex;
    height: 0;
    min-height: 400px;
    // overflow: hidden;
}
.news-wrap{
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}
.news-content{
    max-width: 1220px;
    // min-height: 400px;
    box-sizing: border-box;
    // height: 400px;
    padding: 0 40px 40px;
    width: 100%;
    margin: 0 auto;
    overflow-y: auto;
    background: #fff;
}
.ul-report{
    border-radius: 4px;
    background: #fff;
    // min-height: 520px;
    .li-item{
        display: flex;
        justify-content: space-between;
        font-size: 14px;
        line-height: 56px;
        border-bottom: 1px solid #EDEDF0;
        color: #909BB3;
        a{
            color: #333;
        }
        .time{
            padding: 0 11px 0 23px;
        }
        .li-item-text{
            flex: 1;
            overflow: hidden;
            display: flex;
            align-items: center;
        }
        .text{
            padding: 0 9px 0 2px;
            overflow: hidden;
            white-space: nowrap;
            flex-shrink: 20;
            // background: url('../../../assets/images/icons/icon-new.png') no-repeat right center;
            // background-size: 25px 18px;
        }
        .new{
            width: 25px;
            height: 18px;
            background: url('../../../assets/images/icons/icon-new.png') no-repeat right center;
            background-size: 25px 18px;
        }
    }
    .li-flex{
        padding: 0 10px;
        position: relative;
        &::before{
            content: '';
            position: absolute;
            left: 2px;
            top: 0;
            bottom: 0;
            margin: auto;
            width: 3px;
            height: 11px;
            background: #eee;
        }
        &:hover{
            background: #F7F7FB;
            a{
                color: #05B555;
                text-decoration: underline;
            }
            &::before{
                background: #05B555;
            }
        }
    }
    .more{
        text-align: center;
        cursor: pointer;
        color: #05B555;
        font-size: 14px;
        line-height: 64px;
        .el-icon-arrow-right{
            font-size: 12px;
            margin-left: 5px;
        }
    }
}
</style>
